import type { ProblemItem } from '../lib/domain';
import { useUnits } from '../lib/units';

const KIND_LABEL: Record<ProblemItem['kind'], string> = { UNAVAILABLE: 'nicht erhältlich', PARTIAL: 'teilweise erhältlich', OPEN: 'nicht bearbeitet' };
const KIND_BADGE: Record<ProblemItem['kind'], string> = { UNAVAILABLE: 'danger', PARTIAL: 'warn', OPEN: '' };

// Übersicht der nicht oder nur teilweise erhältlichen Artikel.
export function ProblemItems({ items, scope }: { items: ProblemItem[]; scope: string }) {
  const units = useUnits(scope);
  if (items.length === 0) return <p className="muted">Alle Artikel waren vollständig erhältlich. 🎉</p>;
  return (
    <ul className="list-reset stack">
      {items.map((i) => (
        <li key={i.listItemId} className="card stack">
          <div className="row between">
            <strong>{i.name}</strong>
            <span className={`badge ${KIND_BADGE[i.kind]}`}>{KIND_LABEL[i.kind]}</span>
          </div>
          {i.note && <div className="badge warn" style={{ alignSelf: 'flex-start' }}>{i.note}</div>}
          <div className="muted">
            Gekauft {i.fulfilledQuantity} von {i.targetQuantity} {units.label(i.unit)} · fehlt: {i.missingQuantity} {units.label(i.unit)}
          </div>
        </li>
      ))}
    </ul>
  );
}
